import type { FC } from 'react';
import type { IPopularSearchData, ISearchOverlayTitles } from '@/components/SearchOverlay/types';
import { MetaDataNextSEO } from '@/components/MetaDataNextSEO/MetaDataNextSEO';
import ClientRecipeNotFoundPage from '@/components/PageLevelComponents/ClientRecipeNotFoundPage';

interface RecipeNotFoundPageProps {
  popularSearchData?: IPopularSearchData;
  slug: string;
  searchOverlayData?: ISearchOverlayTitles;
  locale: string;
  metaData?: any;
  titleRecipe: string;
  descriptionRecipe: string;
}

const RecipeNotFoundPage: FC<RecipeNotFoundPageProps> = ({
  popularSearchData,
  slug,
  searchOverlayData,
  locale,
  metaData,
  titleRecipe,
  descriptionRecipe,
}) => {
  return (
    <>
      {metaData && <MetaDataNextSEO metaData={metaData} locale={locale} />}
      <ClientRecipeNotFoundPage
        slug={slug}
        locale={locale}
        popularSearchData={popularSearchData}
        searchOverlayData={searchOverlayData}
        titleRecipe={titleRecipe}
        descriptionRecipe={descriptionRecipe}
      />
    </>
  );
};

export default RecipeNotFoundPage;
